// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3WlqR","filesListContainer":"PosDisputesFiles_filesListContainer__3EXRv","filesButton":"PosDisputesFiles_filesButton__haXaf"};